'use client';

import { Stack, Radio, RadioGroup, Alert, Card, Title } from '@mantine/core';
import { MENTORSHIP_TIMELINES } from '@/constants/mentorshipTimelines';
import classes from '../UnifiedMentorshipApplication.module.css';

interface MentorshipTimelineStepProps {
  value: string;
  onChange: (value: string) => void;
  onAutoAdvance?: () => void;
  error?: string;
}

export default function MentorshipTimelineStep({ 
  value, 
  onChange, 
  onAutoAdvance,
  error 
}: MentorshipTimelineStepProps) {

  const handleChange = (newValue: string) => {
    onChange(newValue);
    // No auto-advance - user must click Next button
  };

  const handleCardClick = (optionValue: string) => {
    // Just update selection, no auto-advance
    handleChange(optionValue);
  };

  return (
    <Stack gap="md" style={{ position: 'relative' }}>
      <Title order={4} style={{ margin: 0, fontWeight: 600 }}>
        What timeline do you have in mind for reaching your goal?
      </Title>

      {error && (
        <Alert color="red" mb="sm">
          {error}
        </Alert>
      )}
      
      <RadioGroup 
        value={value}
        onChange={handleChange}
        className={classes.radioGroup}
      >
        <Stack gap="xs">
          {MENTORSHIP_TIMELINES.map(option => (
            <Card 
              key={option.value} 
              className={`${classes.radioCard} ${value === option.value ? classes.radioCardSelected : ''}`}
              withBorder
              radius="md"
              p="sm"
              style={{ cursor: 'pointer' }}
              onClick={() => handleCardClick(option.value)}
            >
              <Radio 
                value={option.value} 
                label={option.label}
                size="sm"
                styles={{
                  body: { alignItems: 'flex-start' },
                  labelWrapper: { width: '100%' },
                  label: { cursor: 'pointer', paddingLeft: '6px', fontSize: '0.9rem' }
                }}
              />
            </Card>
          ))}
        </Stack>
      </RadioGroup>

    </Stack>
  );
}
